/* JCI EDITS - shared YMM presentation for standard collection and search templates */
(function () {
  'use strict';

  var SECTION_SELECTOR = '.shopify-section--apps';
  var ENHANCED_CLASS = 'jci-collection-list-page__ymm';
  var DARK_CLASS = 'jci-collection-list-page__ymm--dark';
  var LIGHT_CLASS = 'jci-collection-list-page__ymm--light';
  var OPEN_CLASS = 'jci-collection-list-page__ymm--dropdown-open';
  var pageObserver;

  function syncDropdownLayer(section) {
    var hasOpenDropdown = Boolean(section.querySelector(
      '.ss-main.ss-open-below, .ss-main.ss-open-above, .ss-content.ss-open-below, .ss-content.ss-open-above'
    ));

    section.classList.toggle(OPEN_CLASS, hasOpenDropdown);
  }

  function enhance(section) {
    if (!section || !section.matches(SECTION_SELECTOR) || !section.querySelector('#ymm_searchbox #ymm_label')) return false;

    var collectionListRoot = document.querySelector('[data-jci-collection-list][data-ymm-theme]');
    var sharedYmmTheme = document.body.dataset.jciYmmTheme || 'dark';
    var isLightTheme = collectionListRoot
      ? collectionListRoot.dataset.ymmTheme === 'light'
      : sharedYmmTheme === 'light';
    section.classList.add(ENHANCED_CLASS);
    section.classList.toggle(LIGHT_CLASS, isLightTheme);
    section.classList.toggle(DARK_CLASS, !isLightTheme);

    if (!section.jciYmmDropdownObserver && typeof MutationObserver !== 'undefined') {
      section.jciYmmDropdownObserver = new MutationObserver(function () {
        syncDropdownLayer(section);
      });
      section.jciYmmDropdownObserver.observe(section, {
        attributes: true,
        childList: true,
        subtree: true,
        attributeFilter: ['class']
      });
    }

    syncDropdownLayer(section);
    return true;
  }

  function enhanceAll(scope) {
    var target = scope || document;

    if (target.matches && enhance(target)) return true;

    var sections = target.querySelectorAll ? target.querySelectorAll(SECTION_SELECTOR) : [];
    var enhanced = false;

    sections.forEach(function (section) {
      enhanced = enhance(section) || enhanced;
    });

    return enhanced;
  }

  function observeDelayedApp() {
    if (enhanceAll() || typeof MutationObserver === 'undefined') return;

    var main = document.getElementById('main');
    if (!main) return;

    pageObserver = new MutationObserver(function () {
      if (enhanceAll(main)) {
        pageObserver.disconnect();
        pageObserver = null;
      }
    });
    pageObserver.observe(main, { childList: true, subtree: true });
  }

  function cleanup(section) {
    if (!section || !section.matches(SECTION_SELECTOR)) return;

    if (section.jciYmmDropdownObserver) {
      section.jciYmmDropdownObserver.disconnect();
      delete section.jciYmmDropdownObserver;
    }

    section.classList.remove(ENHANCED_CLASS, DARK_CLASS, LIGHT_CLASS, OPEN_CLASS);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeDelayedApp, { once: true });
  } else {
    observeDelayedApp();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (!enhanceAll(event.target)) observeDelayedApp();
  });

  document.addEventListener('shopify:section:unload', function (event) {
    cleanup(event.target);
  });
})();
/* END JCI EDITS */
